import { io } from "socket.io-client";

export let socket = null;

export const connectSocket = (user, url = "http://localhost:4000") => {
  socket = io(url, {
    transports: ["websocket"],
    auth: {
      user: user,
    },
  });

  socket.on("connect", () => {
    // console.log("⚡ Connected:", socket.id);
  });

  socket.on("disconnect", () => {
    // console.log("❌ Disconnected");
  });

  return socket;
};

export const getSocket = () => {
  if (!socket)
    throw new Error("Socket not connected. Call connectSocket() dulu!");
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
